import Components from "./components";

const ModuleName = "tfApp.notification";

export default angular.module(ModuleName, [Components(ModuleName)])
                      .name;
